export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-word-e745a17f119a7835ca0560d6e584c811.svg";